<template>
  <div id="notification_apps">
    <TerrorZoneNavBar />
    <div id="slot-top_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-top_banner" class="desktop-banner hoz-banner"/>
    <Ad placementName="video_slider"/>
    <div class="apps-content">
      <b-tabs content-class="mt-3" class="tab-text">
        <b-tab :title="$t('footer.installText')" active>
          <InstallApp/>
        </b-tab>
        <b-tab :title="$t('footer.useText')">
          <UseApp/>
        </b-tab>
      </b-tabs>
    </div>
    <div id="slot-btm_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-btm_banner" class="desktop-banner hoz-banner"/>
    <TerrorZoneFooter class="mt-4"/>
  </div>
</template>

<script>
import Ad from './components/Ad.vue'
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'
import InstallApp from './components/apps/InstallApp.vue'
import UseApp from './components/apps/UseApp.vue'
import { getLanguage } from '@/utils/common'

export default {
  name: 'NoticationApps',

  components: {
    Ad,
    TerrorZoneNavBar,
    TerrorZoneFooter,
    InstallApp,
    UseApp,
  },

  async created () {
    const language = getLanguage();
    if (language) {
      localStorage.setItem('language', language);
      this.$i18n.locale = language;
    }
  },
}
</script>

<style scoped>
.apps-content {
  color: #fff;
  justify-content: space-around;
  max-width: 900px;
  margin: 40px auto;
  width: 70%;
}
@media (max-width: 600px) {
  .apps-content {
    width: 90%;
  }
}
</style>
